module.exports = __webpack_public_path__ + "1b93ae9e83f3d7881fe579134edb81c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/Mobile.jpg
// module id = 128
// module chunks = 0